module.exports = __webpack_public_path__ + "img/swiper_3.5_2_3.752d9023.webp";